import { ArrowBack } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Stack,
  Typography,
  TypographyProps,
} from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import Container from "./Container";
import LinkBehavior from "./LinkBehavior";

export type Props = PropsWithChildren<
  Pick<TypographyProps, "component" | "variant"> & {
    back?: string;
    action?: ReactNode;
    title?: string | Array<string>;
  }
>;

export default function Title({
  component = "h1",
  variant = "h4",
  back,
  action,
  title,
  children,
}: Props) {
  return (
    <>
      {title && (
        <Helmet
          title={
            Array.isArray(title) ? [...title].reverse().join(" · ") : title
          }
          titleTemplate="%s · Volzalyzer"
          defaultTitle="Volzalzyer"
        />
      )}
      <Container>
        <Stack direction="row" alignItems="center">
          {back && (
            <IconButton href={back} edge="start" component={LinkBehavior}>
              <ArrowBack />
            </IconButton>
          )}
          <Typography component={component} variant={variant}>
            {children}
          </Typography>
          {action && <Box sx={{ ml: "auto" }}>{action}</Box>}
        </Stack>
      </Container>
    </>
  );
}
